// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3ECnU","title":"BackImages_title__x2Bc5","images":"BackImages_images__22gJN"};